import type { RegisteredComponent } from "@builder.io/sdk-react";

import { PlpTopBanner } from "./plp-top-banner";

export const PlpTopBannerDefinition: RegisteredComponent = {
  component: PlpTopBanner,
  name: "PlpTopBanner",
  canHaveChildren: true,
  noWrap: true,
};
